import { CommonModule } from '@angular/common';
import { Component, OnInit, Inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { HeaderComponent as GbHeaderComponent } from '@bookinglab/govbook-ui/layout';
import {
  ImageDetail,
  NavLink,
} from '@bookinglab/govbook-ui/layout/lib/util/model';
@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
	standalone: true,
	imports: [CommonModule, GbHeaderComponent, MatIconModule],
})
export class HeaderComponent {
	goToWebsite() {
		window.open('www.gloucestershire.gov.uk/', '_blank', 'noopener,noreferrer');
	}

	imageDetail: ImageDetail = {
		alt: 'Gloucestershire County Council',
		src: 'assets/gcc-logo.svg',
	};

	navigation: NavLink[] = [
		{
			text: 'News',
			url: 'https://www.gloucestershire.gov.uk/gcc-news/',
		},
		{
			text: 'Subscribe',
			url: 'https://www.gloucestershire.gov.uk/subscribe/',
		},
		{
			text: 'Jobs',
			url: 'https://careers.gloucestershire.gov.uk/go/All-County-Council-Jobs/8557955/',
		},
		{
			text: 'Contact us',
			url: 'https://www.gloucestershire.gov.uk/contact/customer-services/',
		},
	];

	search(term: string) {
		const formatted = term.trim().replace(/\s+/g, '%20');
		const url = `https://www.gloucestershire.gov.uk/search/?pageNumber=1&searchText=${formatted}&dateFilterType=1`;
		window.location.href = url;
	}
}
